import {
  BrowserRouter,
  Route,
  Routes
} from 'react-router-dom';
import Login from './Pages/Auth/Login/Login';
import Homepage from './Pages/Homepage/Homepage';
import { Provider } from 'react-redux';
import { store } from './Store/store';
import { Toaster } from 'react-hot-toast';
import Recipes from './Pages/Recipes/Recipes';
import Settings from './Pages/Settings/Settings';
import Blogs from './Pages/Blogs/Blogs';
import Qna from './Pages/Qna/Qna';
import Tags from './Pages/Tags/Tags';

export default function App() {

  //TODO:
  //Recipe Update ekle
  //Blog Update ekle
  //Terms and conditions admin panelden update edilebilecek

  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/dashboard' element={<Homepage />} />
          <Route path='/recipes' element={<Recipes />} />
          <Route path='/settings' element={<Settings />} />
          <Route path='/qna' element={<Qna />} />
          <Route path='/blogs' element={<Blogs />} />
          <Route path='/tags' element={<Tags />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </Provider>
  )
}